import { createContext, useContext } from "react";
import type { TableColumnOverflow } from "./types";

export interface TableCellContextValue {
  overflow: TableColumnOverflow;
  /** The column's rendered content width in pixels; undefined outside a table or before measuring. */
  contentWidth?: number;
  /** A capped `expand` cell's height budget for its content in pixels; undefined when uncapped. */
  maxContentHeight?: number;
}

const TableCellContext = createContext<TableCellContextValue>({ overflow: "truncate" });

export const TableCellContextProvider = TableCellContext.Provider;

/**
 * The overflow mode of the column the caller renders in, however deeply nested inside the cell.
 * Outside a table cell it reads as `"truncate"`.
 */
export const useTableCellOverflow = (): TableColumnOverflow => useContext(TableCellContext).overflow;

/** The rendered content width of the column the caller renders in; undefined outside a table cell. */
export const useTableCellContentWidth = (): number | undefined => useContext(TableCellContext).contentWidth;

/** The content height a capped `expand` cell allows; undefined outside one. */
export const useTableCellMaxContentHeight = (): number | undefined => useContext(TableCellContext).maxContentHeight;
